import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

// Rename this to getCompetenciesCoreFeatureAvailability
export const useCompetenciesFeatureAvailability = () => {
  const { loading, featureAvailability: reviewsFeatureAvailability } = useFeatureAvailability(
    Features.competencies_core
  )

  return {
    loading: loading,
    competenciesAvailable: reviewsFeatureAvailability.available,
  }
}
